// Utility functions for report operations

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};

export const calculateInvoiceTotals = (doctorServices, selectedServices) => {
  const selectedServicesList = doctorServices.filter(s => selectedServices.includes(s.id));
  const subtotal = selectedServicesList.reduce((sum, service) => sum + (service.price || 0), 0);
  const total = subtotal
  
  return { subtotal,  total, selectedServicesList };
};

export const generateCSV = (columns, reportRows, getTextFor, patientName) => {
  const header = [
    '"Date"',
    ...columns.map(col => `"${col.title.replace(/"/g, '""')}"`)
  ];

  const rows = reportRows.map(row => {
    const dateCell = `"${formatDate(row.bookingDate)}\t"`;
    const dataCells = columns.map(col => {
      const text = getTextFor(col.id, row.bookingId) || '';
      return `"${text.replace(/\r?\n/g, '\\n').trim()}"`;
    });
    return [dateCell, ...dataCells];
  });

  const csvContent = [header.join(', '), ...rows.map(r => r.join(', '))].join('\r\n');
  
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: 'text/csv;charset=utf-8;'
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute(
    'download',
    `${patientName || 'patient'}-report-${new Date().toISOString().slice(0, 10)}.csv`
  );

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const getTextFor = (reportRows, columnId, bookingId) => {
  const row = reportRows.find((r) => r.bookingId === bookingId);
  if (!row) return "";
  const cell = row.cells.find((c) => c.columnId === columnId);
  return cell?.text || "";
};

export const getPhotoIdFor = (reportRows, columnId, bookingId) => {
  const row = reportRows.find((r) => r.bookingId === bookingId);
  if (!row) return null;
  const cell = row.cells.find((c) => c.columnId === columnId);
  return cell?.photoId || null;
};